import React from 'react';

import { useClearByOnDemand, SUBMISSION_STATE } from '../Contexts/ClearByOnDemandProvider';
import ClearErrorModalView from '../Components/ClearErrorModal';

const ClearErrorModal = () => {
  const [submissionState, , { submitTicket, reset }] = useClearByOnDemand();

  return (
    <ClearErrorModalView
      isOpen={true}
      onResendQuestion={submitTicket}
      onBackToClassroom={reset}
      loading={submissionState === SUBMISSION_STATE.RE_SUBMITTING}
    />
  );
};

export default ClearErrorModal;
